import { render, staticRenderFns } from "./MypageCardsPage.vue?vue&type=template&id=0ac81d75&"
import script from "./MypageCardsPage.vue?vue&type=script&lang=js&"
export * from "./MypageCardsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports